import { getIcsLinkKey } from "../../../../commons/utils/utils";

export default function openDeviceCalendar (app) {
    const appClient = this.env.appClientStore;
    let calKey = getIcsLinkKey(app);
    if (!calKey) {
        calKey = getIcsLinkKey("apple");
    }

    const calendarURL = this.calendarURL[calKey];

    console.log('appStore.openDeviceCalendar() -> app: ', app);
    // console.log('openDeviceCalendar() -> CalendarURL: ', calendarURL);
    const flags = this.flags;

    if (isMobileFirefoxOrIntegrated(flags)) {
        openCalendarInMobileIntergratedFirefox(calendarURL);
    } else if (flags.embedded) {
      // embedded means loaded Via Button
        
        if (flags.safari && flags.ios) {
          appClient.openDeviceCalendar(calendarURL, {
            flags,
          });
        } else {
          appClient.openDeviceCalendar(calendarURL);
        }
    } else {
        console.log('appStore.openDeviceCalendar() will open directly?');
        if (flags.safari && flags.ios) {
          openCalendarVialink(calendarURL);
        } else {
          window.location.assign(calendarURL);
        }
    }

};

function openCalendarVialink (calendarURL) {
  console.log('AppStore.openCalendarVialink(): ', calendarURL);
  const a = document.createElement('a');
  a.style = 'display: none';
  
  a.href = calendarURL;
  a.innerHTML = 'open calendar';
  document.body.appendChild(a);
  // a.onclick = () => {};
  a.click();
  document.body.removeChild(a);
}

function isMobileFirefoxOrIntegrated (flags) {
    return (flags.embedded && flags.mobile && flags.firefox) || flags.integrated;
}

function openCalendarInMobileIntergratedFirefox (url) {
    const a = document.createElement('A');
    a.href = url;
    a.target = '_top';
    a.dispatchEvent(new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: false
    }));
}
  

/*


function* openExternalApp() {
  const url = yield select(getIcsLink);
  try {
    const embedded = yield select(getEmbedded);
    const ref = yield select(getAppWidgetRef);
    const integrated = yield select(getIsIntegrated);
    const flags = (yield select(getFlags)).toJS();
    if ((embedded && flags.mobile && flags.firefox) || integrated) {
      dispatchViaAnchor(url);
    } else if (embedded) {
      window.parent.postMessage(JSON.stringify({
        type: WIDGET_LOCATION_ASSIGN,
        payload: {
          ref,
          token: POST_MESSAGE_TOKEN,
          message: url,
        },
      }), '*');
    } else {
      window.location.assign(url);
    }

    // window.open(url.replace('webcal', 'https'), '_blank');
    yield put({ type: CALENDAR_SYNC_SUCCESS });
  } catch (error) {
    yield put({
      type: CALENDAR_SYNC_FAILURE,
      data: { url },
    });
    throw error;
  }
}


*/